<template>
  <div class="indented">
    <p v-for="(item, i) in filteredItems" :key="i">
      <strong>{{ item.label }}</strong>: {{ item.status }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Doctor } from "@/types";
import { camelCase } from "change-case";

export default defineComponent({
  props: {
    doctor: {
      required: true,
      type: Object as PropType<Doctor>,
    },
    labels: {
      required: false,
      type: Object,
    },
    dataKey: {
      required: true,
      type: String as PropType<"culturalCompetencyTypes" | "newPatientTypes">,
    },
    labelDetailsKey: {
      required: true,
      type: String as PropType<"culturalCompetencyDetails" | "newPatientDetails">,
    },
  },
  computed: {
    filteredItems(): Array<{ label: string; status: string }> {
      const details = this.labels?.[this.labelDetailsKey];
      const dataArray = this.doctor?.[this.dataKey];

      if (!details || !dataArray) return [];

      return dataArray
        .map((item: string) => {
          const [label, status] = item.split(" : ");
          const camelCaseKey = camelCase(label);
          const detail = details[camelCaseKey];

          if (!detail || detail.hide) return null;

          return {
            label: detail.label || label,
            status: status,
          };
        })
        .filter(Boolean) as Array<{ label: string; status: string }>;
    },
  }
});
</script>

<style scoped>
.indented {
  margin-left: 1.5rem;
}
</style>
